import {
  CACHED_GQL_FALLBACK_PROP_NAME,
  prefetchLayoutCachedGql,
} from "@/graphql/prefetchCachedGql";
import { gql } from "@apollo/client";
import Head from "next/head";
import { isProductionEnvironment } from "mt-shared/environment";
import MarkdownDocument from "../components/Cards/MarkdownDocument";
import { addApolloState, initializeApollo } from "../graphql/apolloClient";

export default function TermsOfService({ result, shouldReload }) {
  if (shouldReload && typeof window !== "undefined" && !!window)
    window.location.reload();

  return (
    <>
      <Head>
        <title>Terms of Service</title>
      </Head>
      <MarkdownDocument result={result} />
    </>
  );
}

const GET_HTML_CONTENT = gql`
  query ToSHTMLContentQuery($name: String!) {
    htmlContent(pageName: $name) {
      html
    }
  }
`;

const revalidate = isProductionEnvironment ? 3600 : 60;
export const getStaticProps = async () => {
  try {
    const apolloClient = initializeApollo();
    const result = await apolloClient.query({
      query: GET_HTML_CONTENT,
      variables: {
        name: "terms-of-service",
      },
    });

    if (!result.data.htmlContent) {
      return {
        notFound: true,
      };
    }

    return addApolloState(apolloClient, {
      props: {
        [CACHED_GQL_FALLBACK_PROP_NAME]: await prefetchLayoutCachedGql(),
        result,
        shouldReload: false,
      },
      revalidate,
    });
  } catch {
    return {
      props: {
        result: {
          data: {
            htmlContent: {
              html: null,
            },
          },
        },
        shouldReload: true,
      },
      revalidate: 1,
    };
  }
};
